import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../utils";
import { UserContext } from "./UserContext";

const Layout = () => {
    const { subscription } = useContext(UserContext);

    const { userProfile, profileData, setProfileData } = useContext(UserContext);
    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const [profileData, setProfileData] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!token) {
            setError("Token is missing. Please login again.");
            setLoading(false);
            return;
        }
        const fetchProfileData = async () => {
            try {
                const response = await axios.get(baseUrl + "user_api/getProfileData", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.data.status) {
                    const data = response.data.results;
                    setProfileData(Array.isArray(data) ? data[0] : data);
                } else {
                    setError("Failed to fetch profile data.");
                }
            } catch (error) {
                setError("Error fetching profile data: " + error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchProfileData();
    }, [token]);

    const Dashborddata = [
        { label: 'Dashboard', icons: <i className="ri-dashboard-fill"></i>, path: '/dashboard' },
        { label: 'My Plan', icons: <i className="ri-vip-crown-fill"></i>, path: '/dashboard/subscription' },
        { label: 'Exam Alerts', icons: <i className="ri-notification-3-fill"></i>, path: '/dashboard/exam-alerts' },
        { label: 'My Tests', icons: <i className="ri-profile-line"></i>, path: '/dashboard/examList' },
        { label: 'My Counselling', icons: <i class="ri-group-fill"></i>, path: '/dashboard/counselling' },
        { label: 'My Materials', icons: <i className="ri-book-open-fill"></i>, path: '/dashboard/myMaterials' },
        { label: 'My Resume', icons: <i class="ri-survey-fill"></i>, path: '/dashboard/resume' },
        { label: 'Profile Update', icons: <i className="ri-edit-line"></i>, path: '/profileUpdate' },
        { label: 'Logout', icons: <i class="ri-logout-circle-r-line"></i>, path: "/logout" },
    ];

    const handleTabClick = (e, item, index) => {
        e.preventDefault();
        if (location.pathname === '/QuizForm') {
            setModalData(item);
            setShowModal(true);
        } else {
            setActiveIndex(index);
            navigate(item.path);
        }
    };

    const handleModalConfirm = () => {
        setShowModal(false);
        setActiveIndex(Dashborddata.findIndex(item => item.path === modalData.path));
        navigate(modalData.path);
    };

    const handleModalCancel = () => {
        setShowModal(false);
    };

    const [menuitems, setmenuitems] = useState(false);

    const pageTitleMap = {
        '/dashboard': 'Dashboard',
        '/dashboard/subscription': 'My Plan',
        '/dashboard/notification': 'Notifications',
        '/dashboard/exam-alerts': 'Exam Alerts',
        '/dashboard/examList': 'My Tests',
        '/dashboard/counselling': 'My Counselling',
        '/dashboard/myMaterials': 'My Materials',
        '/dashboard/resume': 'My Resume',
        '/profileUpdate': 'Profile Update'
    };

    const iconMap = {
        '/dashboard': 'ri-dashboard-fill',
        '/dashboard/subscription': 'ri-vip-crown-fill',
        '/dashboard/notification': 'ri-notification-3-fill',
        '/dashboard/exam-alerts': 'ri-notification-3-fill',
        '/dashboard/examList': 'ri-profile-line',
        '/dashboard/counselling': 'ri-group-fill',
        '/dashboard/myMaterials': 'ri-book-open-fill',
        '/dashboard/resume': 'ri-survey-fill',
        '/profileUpdate': 'ri-edit-line'
    }
    
    const currentTitle = pageTitleMap[location.pathname] || 'Dashboard';
    const currentIcon = iconMap[location.pathname] || 'Dashboard';
    return (
        <div className="container-fluid">
            <div className="row bg-[#F2F2F2]">

                {/* ✅ Mobile Navbar Section */}
                <div className='py-2 md:hidden block fixed top-0 left-0 bg-white z-[999999]'>
                    <div className='flex justify-between items-center'>
                        <div className="text-center">
                            <img src="/assates/Logo__newimage-removebg-preview.png" className="w-[80px] rounded-lg" />
                        </div>

                        <button className='mb-2' onClick={() => setmenuitems(!menuitems)}>
                            <i class="ri-menu-3-line text-[17px] cursor-pointer"></i>
                        </button>

                        {menuitems && (
                            <div className='w-full absolute top-[70px] left-0 bg-white px-2 py-4'>
                                {Dashborddata.map((item, index) => (
                                    <div
                                        key={index}
                                        onClick={(e) => {
                                            handleTabClick(e, item, index);
                                            // ✅ Automatically close menu after click
                                            setmenuitems(false);
                                        }}
                                        className={`d-flex align-items-center p-3 mb-2 cursor-pointer rounded ${activeIndex === index ? 'bg-black text-white' : 'bg-white text-black'}`}
                                    >
                                        <div>{item.icons}</div>
                                        <span className="ms-2 text-decoration-none text-[600]">
                                            {item.label}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* ✅ Desktop Sidebar */}
                <div className="col-lg-3 bg-light p-3 md:block hidden">
                    <div className="text-center mb-4 flex items-center justify-center">
                        <img src="/assates/Logo__newimage-removebg-preview.png" className="w-[200px] rounded-lg" />
                    </div>
                    <div>
                        {Dashborddata.map((item, index) => (
                            <div
                                key={index}
                                onClick={(e) => handleTabClick(e, item, index)}
                                className={`d-flex align-items-center p-3 mb-2 cursor-pointer rounded ${activeIndex === index ? 'bg-black text-white' : 'bg-white text-black'}`}
                            >
                                <div>{item.icons}</div>
                                <span className="ms-2 text-decoration-none text-[600]">
                                    {item.label}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ✅ Main Content */}
                <div className="col-lg-9 md:p-4 p-2 bg-[#F2F2F2]">
                    <header className="d-flex md:mt-0 mt-24 justify-content-between align-items-center bg-dark text-white p-3 mb-4 rounded">
                        <div className="d-flex align-items-center">
                            <i class={`${currentIcon} fs-5`}></i>
                            {/* <img src="/assates/Dashbord_icons.svg" alt="Dashboard" className="w-25" /> */}
                            <h1 className="ms-2 text-nowrap">{currentTitle}</h1>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                            <h5 className='me-2'>{`${subscription?.plan}`}</h5>
                            <button className="md:block hidden position-relative" onClick={() => { navigate('/dashboard/notification'); }}>
                                <span className="position-absolute top-0 start-100 translate-middle rounded-circle p-1">
                                    <i class="ri-notification-fill text-[25px]"></i>
                                </span>
                            </button>
                            <div className="d-flex align-items-center gap-2" onClick={() => { navigate('/ProfileUpdate'); }}>
                                <img
                                    src={profileData?.profile_img}
                                    alt="User"
                                    className="w-10 rounded-circle"
                                />
                                <span>{userProfile && userProfile.name ? userProfile.name : (profileData && profileData.name ? profileData.name : 'Guest')}</span>
                            </div>
                        </div>
                    </header>

                    <Outlet />
                </div>
            </div>

            {/* ✅ Confirmation Modal */}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-8 shadow-lg text-center w-96">
                        <h2 className="text-2xl font-semibold text-gray-900 mb-6">Warning</h2>
                        <p className="text-gray-700 text-lg mb-6">Are you sure you want to exit?</p>
                        <div className="flex justify-center gap-4">
                            <button
                                type="button"
                                className="px-6 py-2 bg-gray-300 text-gray-800 font-medium rounded-lg hover:bg-gray-400 focus:outline-none transition duration-200"
                                onClick={handleModalCancel}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="px-6 py-2 bg-blue-500 text-white font-medium rounded-lg hover:bg-blue-600 focus:outline-none transition duration-200"
                                onClick={handleModalConfirm}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Layout;
